/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';
import root from 'window-or-global';
import { inject, observer } from 'mobx-react';
import shareIcon from 'common/images/shareIcon.png';
import Header5 from 'elements/Header5';

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from 'react-share';

const ShareBox = styled.div`
  zoom: 0.85;

  ${media.mobile`
    zoom: 1;
  `}

  ${media.desktop`
      position:relative;
      height:55px;
      width:120px;
      border:2px solid ${ds.brand('white')};
      border-radius:${ds.get('metrics.base')};
      overflow:hidden;
      background-color:${ds.brand('darkBackground')};
      transition:height 0.4s, background-color 0.4s, border 0.4s;
      transition-delay: 0.12s;
      margin-top:${ds.get('metrics.s')};

      &:hover{
          height:200px;
          border:2px solid ${ds.brand('darkBackground')};
          background-color:${ds.brand('white')};
      };
  `};
`;

const ShareIcon = styled.div`
  background-image: url(${shareIcon});
  height: 35px;
  width: 35px;
  background-repeat: no-repeat;
  margin: ${ds.get('metrics.xs')} auto ${ds.get('metrics.s')};
`;

const SharesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${ds.get('metrics.xs')};

  ${media.desktop`
    flex-direction: column;
    margin-top: 0;
  `};
`;

const socialShareButton = css`
  outline: none;
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  height: 26px;
  width: 100px;
  margin: 8px ${ds.get('metrics.xs')} 8px 0;
  opacity: 0.95;
  justify-content: ${({ isPolishLanguage }) => isPolishLanguage ? 'flex-start' : 'center'};
  &:hover {
    opacity: 1;
  }

  ${media.mobile`
      margin: 8px ${ds.get('metrics.s')} 8px 0;
    `}

  ${media.desktop`  
      margin: 5px auto;
    `};
`;

const FacebookShare = styled(FacebookShareButton)`
  ${socialShareButton};
  background-color: ${({ color }) => color};
`;

const TwitterShare = styled(TwitterShareButton)`
  ${socialShareButton};
  background-color: ${({ color }) => color};
`;

const LinkedinShare = styled(LinkedinShareButton)`
  ${socialShareButton};
  background-color: ${({ color }) => color};
  margin-right: 0;
`;

const ShareText = styled(Header5)`
  font-size: ${ds.fs('s')};
  color: ${ds.brand('white')};
  margin: 0;
  padding-top: 1px;
  padding-right: ${({ isPolishLanguage }) => isPolishLanguage ? '6px' : '10px'};
`;

@inject('windowStore', 'coreStore', 'appStore')
@observer
export default class ShareMechanism extends Component {
  render() {
    const url = root.location.href;
    const {
      windowStore,
      coreStore: { translations },
      appStore: { isPolishLanguage },
    } = this.props;

    return (
      <ShareBox>
        {!windowStore.isOnTablet && <ShareIcon />}
        <SharesList>
          <FacebookShare
            url={url}
            color={ds.color('social', 'fb')}
            isPolishLanguage={isPolishLanguage}
          >
            <FacebookIcon size={28} round={false} />
            <ShareText isPolishLanguage={isPolishLanguage} bold>
              {translations.BLOG_SHARE}
            </ShareText>
          </FacebookShare>
          <TwitterShare
            url={url}
            color={ds.color('social', 'tw')}
            isPolishLanguage={isPolishLanguage}
          >
            <TwitterIcon size={28} round={false} />
            <ShareText isPolishLanguage={isPolishLanguage} bold>
              {'Tweet'}
            </ShareText>
          </TwitterShare>
          <LinkedinShare
            url={url}
            color={ds.color('social', 'link')}
            isPolishLanguage={isPolishLanguage}
          >
            <LinkedinIcon size={28} round={false} />
            <ShareText isPolishLanguage={isPolishLanguage} bold>
              {translations.BLOG_SHARE}
            </ShareText>
          </LinkedinShare>
        </SharesList>
      </ShareBox>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/ShareMechanism/index.jsx